class ConfigurationClass {

  /**
   * @param {string} key
   */
  read(key) {
    let obj = JSON.parse(localStorage.getItem("humaniti") || "{}");
    return obj[key];
  }

  /**
   * @param {string} key
   * @param {any} value
   */
  write(key, value) {
    let obj = JSON.parse(localStorage.getItem("humaniti") || "{}");
    obj[key] = value;
    localStorage.setItem("humaniti", JSON.stringify(obj));
  }

  /**
   * @param {string} key
   */
  delete(key) {
    let obj = JSON.parse(localStorage.getItem("humaniti") || "{}");
    delete obj[key];
    localStorage.setItem("humaniti", JSON.stringify(obj));
  }

}

let Configuration = new ConfigurationClass();
export default Configuration;